import { ReactNode } from 'react'
import { Fetcher, SWRConfig, Cache } from 'swr'
import { PublicConfiguration } from 'swr/_internal'
// eslint-disable-next-line
type Provider = { provider?: (cache: Readonly<Cache<any>>) => Cache<any> }

export async function customFetcher(url: string) {
  const res = await fetch(url)

  // If the status code is not in the range 200-299,
  // we still try to parse and throw it.
  if (!res.ok) {
    const json = (await res.json()) as { message: string }
    throw new Error(json.message)
  }

  return res.json()
}

interface Props {
  children?: ReactNode
  // eslint-disable-next-line
  swrConfig?: Partial<PublicConfiguration<any, any, Fetcher<any>>> & Provider
}
export const MySwrConfig = ({ children, swrConfig }: Props) => (
  <SWRConfig value={{ fetcher: customFetcher, ...swrConfig }}>
    {children}
  </SWRConfig>
)
